module.exports = __webpack_public_path__ + "img/c3.ab72d617.png";